import Style from './mosaico.module.scss';
import React, { useEffect, useRef, useState } from 'react';
import { TemplatesNav } from 'components/lib';
import axios from 'axios';

export function Mosaico() {
  const frame = useRef(null);
  const current = useRef({ name: 'Nueva plantilla', id: null, state: null });
  const saving = useRef(false);
  const [name, setName] = useState('Nueva plantilla');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [templates, setTemplates] = useState([]);
  const [version, setVersion] = useState(0);
  const refresh = () => axios.get('/api/templates').then(res => setTemplates(res.data.data.filter(item => item.editable)));

  useEffect(() => {
    refresh().catch(() => setError('No se pudieron cargar las plantillas guardadas.'));
    const receive = async event => {
      if (event.origin !== window.location.origin || event.source !== frame.current?.contentWindow) return;
      const reply = data => event.source.postMessage(data, window.location.origin);
      if (event.data?.type === 'gravity-image-upload' || event.data?.type === 'gravity-image-list') {
        try {
          const result = event.data.type === 'gravity-image-upload'
            ? await axios.post('/api/user/template-images', { name: event.data.name, data: event.data.data })
            : await axios.get('/api/user/template-images');
          const absolute = item => ({ ...item, url: new URL(item.url, window.location.origin).href, thumbnailUrl: new URL(item.thumbnailUrl, window.location.origin).href });
          reply({ type: 'gravity-image-result', requestId: event.data.requestId,
            files: (Array.isArray(result.data.data) ? result.data.data : [result.data.data]).map(absolute) });
        } catch (err) {
          reply({ type: 'gravity-image-result', requestId: event.data.requestId, error: err.response?.data?.message || 'No se pudo cargar la imagen.' });
        }
        return;
      }
      if (event.data?.type === 'gravity-template-ready') {
        reply({ type: 'gravity-template-init', state: current.current.state });
        return;
      }
      if (event.data?.type !== 'gravity-template-save' || saving.current) return;
      saving.current = true;
      setError(''); setMessage('Guardando…');
      try {
        const result = await axios.post('/api/user/template', {
          id: current.current.id, name: current.current.name,
          templateHtmlToString: event.data.html, editorState: event.data.state, background: '#fff'
        });
        current.current.id = result.data.data._id;
        current.current.state = event.data.state;
        reply({ type: 'gravity-template-result' });
        setMessage('Plantilla guardada. Ya está disponible en Campañas.');
        refresh().catch(() => {});
      } catch (err) {
        const text = err.response?.data?.message || 'No se pudo guardar. Inténtalo de nuevo.';
        reply({ type: 'gravity-template-result', error: text });
        setError(text); setMessage('');
      } finally { saving.current = false; }
    };
    window.addEventListener('message', receive);
    return () => window.removeEventListener('message', receive);
  }, []);

  const open = async id => {
    if (saving.current) return;
    try {
      const item = id ? (await axios.get(`/api/user/template/${id}`)).data.data : null;
      current.current = { id: item?._id || null, name: item?.name || 'Nueva plantilla', state: item?.editorState || null };
      setName(current.current.name); setMessage(''); setError(''); setVersion(value => value + 1);
    } catch (_) { setError('No se pudo abrir la plantilla.'); }
  };

  return <>
    <TemplatesNav />
    <div className={Style.toolbar}>
      <label>Nombre de la plantilla <input aria-label="Nombre de la plantilla" maxLength={120} value={name} onChange={e => { setName(e.target.value); current.current.name = e.target.value; }} /></label>
      <label>Abrir plantilla guardada <select aria-label="Abrir plantilla guardada" value="" onChange={e => open(e.target.value)}><option value="" disabled>Selecciona una plantilla</option>{templates.map(item => <option key={item.key} value={item.key}>{item.name}</option>)}</select></label>
      <button type="button" onClick={() => open(null)}>Nueva plantilla</button>
    </div>
    {message && <p role="status">{message}</p>}
    {error && <p role="alert">{error}</p>}
    <iframe key={version} ref={frame} title="Editor Mosaico" src="/mosaico/editor.html" className={Style.editor} />
  </>;
}
